module.exports = __webpack_public_path__ + "public/img/logo.2adcb32c.png";